
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutation from "./helper/useUpdateMutation";
  
const API = {
  ADD: `quotation`,
  GET_ALL: `quotation`,
  DELETE: `quotation`,
  UPDATE: `quotation`,

};
const KEY = "quotation"


export const useGetRequestQuotation = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneRequestQuotation = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddRequestQuotation = () => useAddMutation(KEY, API.ADD);
export const useUpdateRequestQuotation = () => useUpdateMutation(KEY, API.UPDATE,true);

export const useDeleteRequestQuotation = () =>useDeleteMutation(KEY, API.DELETE);
